import { render, staticRenderFns } from "./homeRecommand.vue?vue&type=template&id=6b122544&scoped=true&"
import script from "./homeRecommand.vue?vue&type=script&lang=js&"
export * from "./homeRecommand.vue?vue&type=script&lang=js&"
import style0 from "./homeRecommand.vue?vue&type=style&index=0&lang=css&"
import style1 from "./homeRecommand.vue?vue&type=style&index=1&lang=css&"
import style2 from "./homeRecommand.vue?vue&type=style&index=2&id=6b122544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b122544",
  null
  
)

export default component.exports